/**
 * LazySusan Module
 *
 * This module handles the rotating bottle carousel on the homepage
 */

import jQuery from 'jquery';
import ScrollMagic from 'scrollmagic';
import '../../vendor/jquery.enllax.min.js';

const LazySusan = {
  // DOM elements
  carousel: null,
  bottles: null,
  bottleTitles: null,

  // Current active bottle
  currentActive: 0,
  isRotating: false,

  /**
   * Initialize the Lazy Susan carousel
   * @param {object} homeController - ScrollMagic controller
   */
  init: function (homeController) {
    // Call the main initialize function
    this.initialize(homeController);
  },

  /**
   * Main initialization function
   * @param {object} homeController - ScrollMagic controller
   */
  initialize: function (homeController) {
    // Cache DOM elements
    this.carousel = jQuery('.carousel');
    this.bottlesContainer = jQuery('.lazy-susan__container');
    this.bottles = jQuery('.bottle-1, .bottle-2, .bottle-3, .bottle-4');
    this.bottleTitles = jQuery('.bottle-series__container .bottle-series');
    this.nextBtn = jQuery('.lazy-susan__controller .next');
    this.prevBtn = jQuery('.lazy-susan__controller .prev');

    // Set initial counter-rotation if needed
    const initialRotation = this.carousel.data('rotation') || 0;
    if (initialRotation !== 0) {
      this.bottles.each((i, bottleEl) => {
        const bottle = jQuery(bottleEl).find('.item');
        bottle.css('transform', 'rotateY(' + -initialRotation + 'deg)');
      });
    }

    // Bind event handlers
    this.bindEvents();

    // Setup parallax effects
    this.bushParallax();

    // Setup scroll trigger for animation
    this.bottleAnimTrigger(homeController);
  },

  /**
   * Bind event handlers
   */
  bindEvents: function () {
    // Next button click event
    this.nextBtn.on('click', () => {
      if (this.isRotating) return;
      this.rotateNext();
    });

    // Previous button click event
    this.prevBtn.on('click', () => {
      if (this.isRotating) return;
      this.rotatePrev();
    });
  },

  /**
   * Rotate to next bottle
   */
  rotateNext: function () {
    if (this.isRotating) return;
    this.isRotating = true;

    // Get current active bottle
    let nextBottle = null;
    let currentBottle = null;
    let nextTitle = null;
    let currentTitle = null;

    if (jQuery('.bottle-1 .item').hasClass('active')) {
      currentBottle = jQuery('.bottle-1 .item');
      nextBottle = jQuery('.bottle-2 .item');
      currentTitle = jQuery('.bottle-series__container .title-1');
      nextTitle = jQuery('.bottle-series__container .title-2');
    } else if (jQuery('.bottle-2 .item').hasClass('active')) {
      currentBottle = jQuery('.bottle-2 .item');
      nextBottle = jQuery('.bottle-3 .item');
      currentTitle = jQuery('.bottle-series__container .title-2');
      nextTitle = jQuery('.bottle-series__container .title-3');
    } else if (jQuery('.bottle-3 .item').hasClass('active')) {
      currentBottle = jQuery('.bottle-3 .item');
      nextBottle = jQuery('.bottle-4 .item');
      currentTitle = jQuery('.bottle-series__container .title-3');
      nextTitle = jQuery('.bottle-series__container .title-4');
    } else if (jQuery('.bottle-4 .item').hasClass('active')) {
      currentBottle = jQuery('.bottle-4 .item');
      nextBottle = jQuery('.bottle-1 .item');
      currentTitle = jQuery('.bottle-series__container .title-4');
      nextTitle = jQuery('.bottle-series__container .title-1');
    }

    // Rotate the carousel
    let currdeg = this.carousel.data('rotation') || 0;
    currdeg = currdeg - 90;
    this.carousel.css('transform', 'rotateY(' + currdeg + 'deg)');
    this.carousel.data('rotation', currdeg);

    // Counter-rotate all bottles so they face forward
    this.bottles.each((i, bottleEl) => {
      const bottle = jQuery(bottleEl).find('.item');
      bottle.css('transform', 'rotateY(' + -currdeg + 'deg)');
    });

    // Update active classes
    currentBottle.removeClass('active');
    nextBottle.addClass('active');
    currentTitle.removeClass('active');
    nextTitle.addClass('active');

    // Reset rotation status after animation
    setTimeout(() => {
      this.isRotating = false;
    }, 800);
  },

  /**
   * Rotate to previous bottle
   */
  rotatePrev: function () {
    if (this.isRotating) return;
    this.isRotating = true;

    // Get current active bottle
    let prevBottle = null;
    let currentBottle = null;
    let prevTitle = null;
    let currentTitle = null;

    if (jQuery('.bottle-1 .item').hasClass('active')) {
      currentBottle = jQuery('.bottle-1 .item');
      prevBottle = jQuery('.bottle-4 .item');
      currentTitle = jQuery('.bottle-series__container .title-1');
      prevTitle = jQuery('.bottle-series__container .title-4');
    } else if (jQuery('.bottle-2 .item').hasClass('active')) {
      currentBottle = jQuery('.bottle-2 .item');
      prevBottle = jQuery('.bottle-1 .item');
      currentTitle = jQuery('.bottle-series__container .title-2');
      prevTitle = jQuery('.bottle-series__container .title-1');
    } else if (jQuery('.bottle-3 .item').hasClass('active')) {
      currentBottle = jQuery('.bottle-3 .item');
      prevBottle = jQuery('.bottle-2 .item');
      currentTitle = jQuery('.bottle-series__container .title-3');
      prevTitle = jQuery('.bottle-series__container .title-2');
    } else if (jQuery('.bottle-4 .item').hasClass('active')) {
      currentBottle = jQuery('.bottle-4 .item');
      prevBottle = jQuery('.bottle-3 .item');
      currentTitle = jQuery('.bottle-series__container .title-4');
      prevTitle = jQuery('.bottle-series__container .title-3');
    }

    // Rotate the carousel
    let currdeg = this.carousel.data('rotation') || 0;
    currdeg = currdeg + 90;
    this.carousel.css('transform', 'rotateY(' + currdeg + 'deg)');
    this.carousel.data('rotation', currdeg);

    // Counter-rotate all bottles so they face forward
    this.bottles.each((i, bottleEl) => {
      const bottle = jQuery(bottleEl).find('.item');
      bottle.css('transform', 'rotateY(' + -currdeg + 'deg)');
    });

    // Update active classes
    currentBottle.removeClass('active');
    prevBottle.addClass('active');
    currentTitle.removeClass('active');
    prevTitle.addClass('active');

    // Reset rotation status after animation
    setTimeout(() => {
      this.isRotating = false;
    }, 800);
  },

  // Handle parallax effect for bush background
  bushParallax: function () {
    // Uses enllax.js for parallax effect
    jQuery('#bush-background').enllax();
  },

  // Trigger bottle animations
  bottleAnimTrigger: function (homeController) {
    var bottleController = new ScrollMagic.Controller();

    var bottleTrigger = new ScrollMagic.Scene({
      triggerElement: '#lazy-trigger',
      reverse: false,
      offset: 100,
      triggerHook: 0.8,
    })
      .on('start', () => {
        // Trigger the next button click when scrolling to this section
        this.nextBtn.trigger('click');
      })
      .addTo(bottleController);
  },
};

export default LazySusan;
